<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-3">
      <PromocodeIcon />
      <div>
        <p class="text-text-neutral-primary font-medium">
          {{ promocodeModifier.data.value }}
        </p>
        <p class="text-text-positive-primary text-xs">
          {{
            $t('promocode.discountAmount', {
              amount: `${prettyPrice(promocodeModifier.data.price_total)} ₸`,
            })
          }}
        </p>
      </div>
    </div>
    <button
      type="button"
      :disabled="isLoading"
      @click="cancel(promocodeModifier.data.promocode_id)"
    >
      <LoadingIcon v-if="isLoading" class="h-6 w-6 animate-spin" />
      <DeleteIcon v-else class="h-6 w-6 text-gray-400" />
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { Shop } from '@aviata/platform-types';
  import { prettyPrice } from '@aviata/text-fns';

  import PromocodeIcon from '../assets/promocode.icon.svg?component';
  import DeleteIcon from '../assets/delete.icon.svg?component';
  import LoadingIcon from '../assets/loading.icon.svg?component';
  import { useCancelPromocodeMutation } from '../api';

  const props = defineProps<{
    promocodeModifier: Shop.PriceModifier.Promocode;
    orderId: string;
  }>();

  const { mutate: cancel, isLoading } = useCancelPromocodeMutation(
    props.orderId,
    props.promocodeModifier.data.bill_id,
  );
</script>
